module.exports = __webpack_public_path__ + "assets/purple_background.2a19214e013a077b9b2f6a58e9147e48.jpg";